import { IAbUseExperiment } from '../../types/abUseExperiments';
import { NB_HELP_IN_SEARCH } from '../../constants/experiments';

export function isConsultantPopupExperimentActive(experiments: IAbUseExperiment[]) {
  const experiment = experiments.find(e => e.experimentName === NB_HELP_IN_SEARCH);

  if (!experiment || !experiment.groupName) {
    return false;
  }

  return ['version1', 'version2', 'version3'].includes(experiment.groupName);
}
